import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Drawer from '@base/Drawer/Drawer';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import { useToggleable } from '@stores/toggleables';
import { LOGIN_DRAWER } from '@constants/toggleables';
import { breakpoints, Spacings } from '@styles/index';
import { segment } from '@actions/analytics';
import Dynamic from '@base/Dynamic/Dynamic';
import Divider from '@base/Divider/Divider';
import Logo from '@comp/Logo/Logo';
import { LOGIN_STARTED } from '@cont/Login/constants';
import HeaderTop from '../Components/HeaderContainer';
import HeaderContent from '../Components/HeaderParent';

const Login = Dynamic(() => import('@cont/Login/Login'));

const HeaderContainer = styled(HeaderTop)`
  position: initial;
  height: auto;
`;

const HeaderParent = styled(HeaderContent)`
  display: flex;
  justify-content: center;
  margin: ${Spacings.SPACING_10B} auto;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    width: 768px;
    padding: 0px ${Spacings.SPACING_5B};
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
    padding: 0 ${Spacings.SPACING_4B};
  }
`;

const StyledLogo = styled(Logo)`
  @media only screen and (max-width: ${breakpoints.mobile}) {
    grid-column: 1/2;
  }
`;

const StyDivider = styled(Divider)`
  width: 1136px;
  margin: auto;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    width: 768px;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
  }
  background-color: var(--color-divider);
`;

function HeaderComponent({ className }) {
  const {
    isOpen: showLoginDrawer,
    openElement: openLoginDrawer,
    closeElement: closeLoginDrawer
  } = useToggleable(LOGIN_DRAWER);
  const isLoggedIn = useMyInfo(getIsLoggedIn);

  useEffect(() => {
    if (!isLoggedIn) {
      segment.track(LOGIN_STARTED);
      openLoginDrawer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  const onClose = () => {
    closeLoginDrawer();
  };

  return (
    <>
      <HeaderContainer className={className}>
        <HeaderParent>
          <StyledLogo />
        </HeaderParent>
        <StyDivider />
      </HeaderContainer>
      <Drawer
        login
        hideCloseButton
        disableBackdropClick
        disableEscapeKeyDown
        drawerState={showLoginDrawer}
        onClose={onClose}
      >
        <Login />
      </Drawer>
    </>
  );
}

HeaderComponent.propTypes = {
  className: PropTypes.string
};
HeaderComponent.defaultProps = {
  className: ''
};

export default HeaderComponent;
